export default "__VITE_ASSET__DmBvuDM7__"